<div class="sir-slider-container">
    <div class="sir-top">
        @if (carousel && hasSlidesNotInView() && arrowsVisible) {
            @if (carousel.canScrollPrev()) {
                <button
                    siriusButton
                    class="sir-button-prev is-light"
                    [buttonType]="'secondary'"
                    [size]="'large'"
                    [iconName]="'caret_left'"
                    [attr.aria-label]="'slider.prev' | translate"
                    (click)="scrollPrevious()"></button>
            }
            @if (carousel.canScrollNext()) {
                <button
                    siriusButton
                    class="sir-button-next is-light"
                    [buttonType]="'secondary'"
                    [size]="'large'"
                    [iconName]="'caret_right'"
                    [attr.aria-label]="'slider.next' | translate"
                    (click)="scrollNext()"></button>
            }
        }
        <sirius-container [fluid]="layout === 'fluid'">
            <sirius-carousel
                [startIndex]="startIndex"
                [options]="options"
                [clipViewport]="layout === 'fluid'">
                <ng-content></ng-content>
            </sirius-carousel>
        </sirius-container>
    </div>
    @if (carousel && hasSlidesNotInView() && showDots) {
        <div class="sir-dots">
            @for (dot of carousel.scrollSnapList(); track $index) {
                <button
                    type="button"
                    class="sir-dot"
                    [class.sir-is-selected]="$index === carousel.selectedScrollSnap()"
                    [attr.aria-label]="'slider.ariaLabel' | translate: { index: $index + 1 }"
                    [attr.aria-current]="$index === carousel.selectedScrollSnap() ? 'true' : null"
                    (click)="carousel.scrollTo($index)"></button>
            }
        </div>
    }
</div>
